import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlCollingwoodParkPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["collingwood-park"]} />;
}
